import Vue from 'vue';
import VueRouter from 'vue-router';

// Views
import Home from '../views/Home.vue';
import ProductosPorCategoria from '../views/ProductosPorCategoria.vue';
import ProductoDetalle from '../views/ProductoDetalle.vue';
import Drivers from '../views/Drivers.vue';
import Soporte from '../views/Soporte.vue';
import Contacto from '../views/Contacto.vue';
import Blog from '../views/Blog.vue';
import BlogDetalle from '../views/BlogDetalle.vue';
import Videos from '../views/Videos.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home,
        meta: { title: 'Inicio' }
    },
    {
        path: '/productos/:categoriaId/:categoriaSlug',
        name: 'productos.categoria',
        component: ProductosPorCategoria,
        props: true,
        meta: { title: 'Productos' }
    },
    {
        path: '/producto/:id/:slug',
        name: 'producto.detalle',
        component: ProductoDetalle,
        props: true,
        meta: { title: 'Producto' }
    },
    {
        path: '/drivers-descargas',
        name: 'drivers',
        component: Drivers,
        meta: { title: 'Drivers y Descargas' }
    },
    {
        path: '/soporte-tecnico',
        name: 'soporte',
        component: Soporte,
        meta: { title: 'Soporte Técnico' }
    },
    {
        path: '/contacto',
        name: 'contacto',
        component: Contacto,
        meta: { title: 'Contacto' }
    },
    {
        path: '/blog',
        name: 'blog',
        component: Blog,
        meta: { title: 'Blog' }
    },
    {
        path: '/blog/:slug',
        name: 'blog.detalle',
        component: BlogDetalle,
        props: true,
        meta: { title: 'Blog' }
    },
    {
        path: '/videos',
        name: 'videos',
        component: Videos,
        meta: { title: 'Videos' }
    }
];

const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    }
});

router.beforeEach((to, from, next) => {
    const config = window.appConfig;
    const baseTitle = config && config.site_title || 'Soluciones POS';
    document.title = to.meta.title ? `${to.meta.title} - ${baseTitle}` : baseTitle;
    next();
});

export default router;
